import type { ApiError } from '@/types/api'
import { toast } from '@/integrations/toaster-provider'
import { useAuthStore } from '@/features/auth/store/authStore'

export const notifyRequestError = (error: ApiError, defaultMessage: string) => {
  if (error.status === 401) {
    // Check if we're on a public route - don't logout if so
    const PUBLIC_ROUTES = [
      '/login',
      '/reset-password',
      '/complete-setup',
      '/password-requested',
      '/request-reimbursement',
    ]
    const currentPath = window.location.pathname
    const isPublicRoute = PUBLIC_ROUTES.some((route) =>
      currentPath.startsWith(route),
    )

    if (!isPublicRoute) {
      useAuthStore.getState().logout()
    }
  }

  if (!error.response) {
    toast.error(
      'Network error. Please check your internet connection and try again.',
    )
    return
  }

  const description = error.response.data.message || defaultMessage
  toast.error(description)
}
